import { styled, Typography } from "@mui/material";

export const Adornment = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 700,
  width: 40,
  color: theme.palette.primary.main,
}));
